module.exports = {
	"INLINE": "Hello World",
	"nav_home": "Home",
	"nav_about": "Restaurant",
	"nav_menu": "Menu",
	"nav_wines": "Wines",
	"nav_suggestions": "Suggestions",
	"nav_events": "Events",
	"about-title": "About us",
	"nav-feedback": "Feedback",
	"nav-pickly": "About Pickly",
	"follow_text": "Follow us on",
	"desktop_languages": "Languages",
	"intro_default_option": "Filter menu by:",
	"suggested_extras": "Suggested extras",
	"suggested_wines": "Suggested Wines",
	"cta_title": "Check our selection of ",
	"cta_btn": "See our",
	"related_products": "Related products",
	"error_home_link": "Start over",
	"error_home_title1": "Hmm...",
	"error_home_title2": "We couldn't locate the page you were looking for.",
	"error_home_text": "Please check the address or try again later.",
	"detail_title": "in detail",
	"list_event_title": "Events",
	"event_link": "Official website",
	"other_events": "Other Events",
	"filter-group-region-type": "Wine Type and Region",
	"region_default_option": "Choose a region",
	"filters": "Filters",
	"filter-group-type": "Type",
	"type_default_option": "Choose a type",
	"filter-group-flavour": "Flavour",
	"filter-group-characteristics": "Wine Features",
	"sweetness_default_option": "Choose how sweet",
	"filter-group-body": "Body",
	"body_default_option": "Choose a body",
	"filter-group-ingredients": "Main Ingredients",
	"filter-group-diets": "Intolerances",
	"filter-results": "{results} results",
	"filter-clear-button": "Clear filters",
	"filter-apply-button": "Apply",
	"related_dishes": "Related Dishes",
	"empty-title": "No results found",
	"empty-text": "We couldn't find results to meet your search criteria, please try again with different filters",
	"feedback-title": "Help us Improve",
	"feedback-intro": "We kindly ask you to answer this brief evaluation survey. You can also report your reviews and opinions.",
	"feedback-improve": "Did Pickly improve your experience in the restaurant?",
	"feedback-error": "Please select an option",
	"feedback-harder": "Made it Harder",
	"feedback-no-help": "Didn't Help",
	"feedback-indiferent": "Indiferent",
	"feedback-helped": "Helped",
	"feedback-helped-a-lot": "Helped a lot",
	"feedback-recommend": "Would you recommend Pickly to other restaurants?",
	"feedback-no-recommend": "Don't Recommend",
	"feedback-recommend-neutral": "Indiferent",
	"feedback-recommend-yes": "Recommend",
	"feedback-msg": "Would you like to make any suggestion to upgrade the app and/or Pickly’s service? (optional)",
	"feedback-submit": "Submit",
	"feedback-thanks-title": "Thank you",
	"feedback-thanks-text": "Thank you for helping us improve. You can go back to the homepage through the button below.",
	"restaurant-feedback-title": "Your opinion is important.",
	"restaurant-feedback-subtitle": "Help us to improve.",
	"restaurant-feedback-intro": "Tell us about your experience in our restaurant, evaluating the service, food and ambience, through a brief survey.",
	"restaurant-feedback-intro-btn": "Give Feedback",
	"food-feedback-title": "FOOD Evaluation",
	"food-feedback-intro": "Help us improve.",
	"choice-question": "The menu had a nice selection of food",
	"presentation-question": "Good presentation on the items",
	"tasty-question": "Food was tasty and well cooked",
	"service-feedback-title": "SERVICE Evaluation",
	"speed-question": "Restaurant was quick to process our order",
	"waiters-question": "The waiting service was good",
	"overall-question": "overall the service was good",
	"global-feedback-title": "GENERAL Evaluation",
	"deco-question": "Restaurant has a nice deco and atmosphere",
	"price-question": "Good value for money",
	"recommend-question": "Would you recommend the restaurant to a friend?",
	"comments-question": "Comments and suggestions",
	"type": "type",
	"body": "body",
	"region": "region",
	"accidity": "accidity",
	"recommend_title": "Would you recommend this dish?",
	"recommend_title_drink": "Would you recommend this drink?",
	"recommend-total": "{total} clients recommend this dish.",
	"recommend-total_drink": "{total} clients recommend this drink.",
	"mypick-text": "Use myPick to choose your favorite dishes, drinks and deserts for this meal. Then, just ask the waiter.",
	"cookie-notice": "By using this website you agree with the use of cookies for analytics.",
	"cookie-link": "Read more",
	"terms-title": "Terms and conditions",
	"cookies-title": "Cookies Policy",
	"drinks-link-all": "See all",
	"toggle_list": "List",
	"toggle_cards": "Cards",
	"price_under_request": "Price under request"
};


/*****************
 ** WEBPACK FOOTER
 ** ./locales/en-us.json
 ** module id = 274
 ** module chunks = 0
 **/